import React, { useMemo, useState, useRef  ,useEffect, useReducer, fetchData} from 'react';
import { Alert, Button, Container, Card, Table, Modal, Accordion,Form, FormLabel, Col, Row } from 'react-bootstrap';
import { useNavigate } from "react-router";

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload} from '../../services/useBackend_v2';
import MaterialReactTable from 'material-react-table';
import {getOptions} from '../../services/misc';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser, FaFileDownload, FaDownload } from 'react-icons/fa';

import download from 'downloadjs'
import { Link } from 'react-router-dom';

function SellReport() {

    const {loading, data, Refresh, Seek, initReady, XCall} =  useBackend('/api/reports');

    const [resultVariant, setResultVariant] = useState(null);
    const [resultText,    setResultText]    = useState(null);
    const [resultVisible, setResultVisible] = useState(null);
    const [reportVisible, setReportVisible] = useState(false);

    const [reportHasDateFilter, setReportHasDateFilter] = useState(false);

    const [headline, setHeadline] = useState("Rapporter");

    const [reportData, setReportData] = useState(null);
    const [reportColumns, setReportColumns] = useState([]);

    var dataPath = useRef("");

    var today = new Date(Date.now());
    var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [startDate, setStartDate] = useState(firstDayOfMonth.toLocaleDateString());
    
    var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth()+1, 0);
    const [endDate, setEndDate] = useState(lastDayOfMonth.toLocaleDateString());    

        const navigate = useNavigate();

    async function setReportHandler(e) {
        e.preventDefault();

        let type = e.currentTarget.getAttribute("type");

        setHeadline(e.currentTarget.getAttribute("name"));

        if (type=="standardgrid") {
            dataPath.current = e.currentTarget.getAttribute("dataPath");
            //console.log(dataPath.current+"?startdate="+startDate+"&enddate="+endDate);
            loadStandardgrid(dataPath.current);
        }

        if (type=="link") {
            navigate(e.currentTarget.getAttribute("path"));
        }        

        if (type=="download") {
            handleExportData(e.currentTarget.getAttribute("filename"), e.currentTarget.getAttribute("path"));
        }
    }

    async function loadStandardgrid(dataPath) {
            let filter = "";
            if (reportHasDateFilter) filter = "?startdate="+startDate+"&enddate="+endDate;

            console.log(dataPath);
            var {errorsException, jsondata} =  await XCall ( dataPath + filter, "GET", 3000, {}, true);
            setReportData(jsondata[jsondata.datasetName]);
            setReportHasDateFilter(jsondata.reportHasDateFilter);
            if (!errorsException) {


                try {
                    let columnsnew = [];                    
                    var keys = Object.keys(jsondata[jsondata.datasetName][0]);
                    keys.map((f) => columnsnew.push({ size: 10, accessorKey: f,  header: f, enableColumnActions: false }));
                    setReportColumns(columnsnew);    
                } catch {}
                
                setReportVisible(true);
            }
            
    }

    async function goBack() {
        setReportVisible(false);
        setHeadline("Rapporter");
        setReportData(null);
        setReportHasDateFilter(false);
    }



    async function handleExportData(filename, path) {        
        setResultVisible(true);
        setResultText("Påbörjar nedladdning...");
        setResultVariant("info");
        const csv = await CallDownload(path);
        download(csv, filename, 'text/csv')

        setResultText("Nedladdning klar!");

        setTimeout(() => {
            setResultVisible(false);
        }, 3000);     
    };  

    const state = {  };  
    const initialState={
        density: 'compact',
        pagination: { pageIndex: 0, pageSize: 100 }
    }

    useEffect(() => {
        //console.log(dataPath.current+"?startdate="+startDate+"&enddate="+endDate);
        // if (startDate != "" && endDate != ""  ) {
        if (Date.parse(endDate)<Date.parse(startDate) ) { setResultVisible(true); setResultText("Från datum behöver vara större än till datum.");}
        console.log(dataPath.current);
        if (dataPath.current != null && dataPath.current != "")
        loadStandardgrid(dataPath.current);          
        // }
    }, [startDate, endDate]);

    if (initReady) {
        return (
                <ContentWrapper>
                <Container>
                    <Sida>

                        <div width_="100%" style={{ backgroundColor_:"#f00", display: "flex", flexDirection: "row" }}>
                            <div style = {{ float:"left", flex:"1" }}><Rubrik>{headline}</Rubrik></div>
                            <div style = {{ float:"right" }}><Button hidden={reportVisible ? false : true} variant='standard' onClick={ ()=>goBack() }>Tillbaka</Button> </div>
                        </div>

                        {(reportHasDateFilter == true) && (<>                            
                            <div className='d-flex'></div>

                            <Row>
                                <Col>Startdatum</Col>
                                <Col>Slutdatum</Col>
                            </Row>

                            <Row>
                                <Col><Form.Control type="date" name="Name" placeholder="Startdatum" value={startDate} onChange={async (e) => {await setStartDate(e.target.value); }} /></Col>
                                <Col><Form.Control type="date" name="Name_" placeholder="Slutdatum" value={endDate}   onChange={async (e) => {setEndDate(e.target.value); }} /></Col>
                            </Row>
                            <br></br>
                        </>)}

                        {(!loading && !reportVisible) && (<>

                            <ul>
                                {data.reportList.map((p) => (<li>
                                        <div key={p.id}>
                                            <a className="text-decoration-none" style={{color:'#000', fontSize:'20px'}} onClick={setReportHandler} name={p.name} filename={p.filename} path={p.path} type={p.type} dataPath={p.data}><b>{p.name}</b></a><br></br>
                                            <small>{p.description}</small>
                                        </div>
                                    
                                </li>))}
                            </ul>
                        </>)}

                        {(reportVisible) && (<>
                        <MaterialReactTable 
                            //enableColumnActions= {false}
                            columns={reportColumns}
                            data={reportData}
                            //rowCount= {data.totalNumOfRows}

                            // manualPagination= {true}
                            // onPaginationChange={setPagination} 
                            // paginationDisplayMode='pages'
                            
                            // muiSearchTextFieldProps = {{ placeholder: 'Sök på namn...' }}
                            // enableGlobalFilter = {true} // Visa sökruta
					        // manualFiltering = {true}  // Stänger av klientfiltrering
                            // onGlobalFilterChange={(search) => setSearchFilter(search, 750)}

                            // muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            // muiTablePaginationProps={{ showFirstButton: true, showLastButton: true ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            state={state}
                            initialState={initialState}
                            // renderTopToolbarCustomActions={() => (<Rubrik>Besök</Rubrik>)} 

                        /> 
                        </>)}                        
                        <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                        
                    </Sida>
                </Container>
            </ContentWrapper>        
        )
    } else {
        return (<Loading />);        
    }
}

export default SellReport;